export class MDMDetails {
    productCode: string;
    ibmEmmAccountId: string;
    googleEmmAccountId: string;
    samsungEmmAccountId: string;
    appleEmmAccountId: string;
    latestAccountType: string;

    constructor() {
        this.productCode = undefined;
        this.ibmEmmAccountId = undefined;
        this.googleEmmAccountId = undefined;
        this.samsungEmmAccountId = undefined;
        this.appleEmmAccountId = undefined;
        this.latestAccountType = undefined;
    }
}
